export default __webpack_public_path__ + "static/Insights_and_News_Full_Color-638ae7f98c45e6074012aaf9e96db0c6.png";